import http from '@/http'

const state = {
  email: '',
  gender: '',
  birthday: ''
}

const getters = {
  userProfile: (state) => {
    return {
      gender: state.gender,
      birthday: state.birthday
    }
  },
  isLogged: (state) => {
    return !!state.email
  }
}

const mutations = {
  loggedin (state, data) {
    state.email = data.email
  },
  loggedout (state) {
    state.email = ''
    state.gender = ''
    state.birthday = ''
  },
  setProfile (state, data) {
    state.gender = data.gender
    state.birthday = data.birthday
  },
  setEmail (state, data) {
    state.email = data.email
  }
}

const actions = {
  login ({commit}, payload) {
    return http.post('/user/login/', {'id': payload.email, 'password': payload.password}).then(function (response) {
      if (response.result) {
        commit('loggedin', {email: payload.email})
      }
      return response
    })
  },
  logout ({commit}) {
    return http.post('/user/logout/').then(function (response) {
      commit('loggedout')
    })
  },
  changeProfile ({commit}, payload) {
    return http.post('/profile/update/', payload.profile).then(function (response) {
      if (response.result) {
        commit('setProfile', payload.profile)
      }
      return response
    })
  },
  getProfile ({commit}) {
    return http.post('/profile/select/').then(function (response) {
      if (response.result && response.body) {
        commit('setProfile', response.body)
      }
      return response
    })
  },
  getEmail ({commit}) {
    return http.post('/user/select/').then(function (response) {
      if (response.result && response.body) {
        commit('setEmail', response.body)
      }
      return response
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/User.js